import axios from 'axios';
import { call, put, takeEvery, delay } from 'redux-saga/effects';
import { ChatMessageAction, IFetchKeywordData, INode } from './types';
import { ChatSettingAction } from '../chatSetting/types';
import { LoadingChatBotEnd } from '../chatStatus/actions';
import { InsertVisitLog, LoadChatBotMessage } from './actions';
import { InitialLoading } from '../chatStatus/actions';
import { ChatBaseDataAction } from '../chatBaseData/types';

import values from 'lodash/values';

export const generateId = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

function fetchChatDataApi() {
  const apiUrl = process.env.REACT_APP_FETCH_DATA_API!;

  return axios.get(apiUrl).then(response => response.data);
}

export function* fetchChatData() {
  try {
    yield put(InitialLoading());
    const chatbotData = yield call(fetchChatDataApi);

    const chatbotBaseData: INode[] = values(JSON.parse(chatbotData.data));
    yield put({
      type: ChatBaseDataAction.INIT,
      payload: { chatbotData: chatbotBaseData }
    });

    yield put({
      type: ChatMessageAction.FETCH_CHATBOT_DATA_SUCCESS,
      payload: { chatbotData: chatbotBaseData }
    });

    // ローカルに履歴があればそれを読み込む
    const localChatMessage = localStorage.getItem('chat-message');
    if (localChatMessage !== null) {
      const parseData = JSON.parse(localChatMessage);
      // APIエラーで空データが保存されているケースがある
      // その場合は読み込まない
      if (parseData.length > 0 && parseData[0].chatdata_id !== '') {
        yield put(LoadChatBotMessage(parseData));
      }
    }
    // ここで訪問者数ログをとる
    yield put(InsertVisitLog());
    yield put({
      type: ChatSettingAction.INIT_CHATBOT_SETTING,
      payload: { chatSettingData: JSON.parse(chatbotData.setting) }
    });
    yield put(LoadingChatBotEnd());
  } catch (e) {
    yield put({
      type: ChatMessageAction.FETCH_CHATBOT_DATA_FAILURE,
      message: e.message
    });
  }
}

// 送信した文字が形態素解析で分解された文字列の配列で返ってくるAPI
async function fetchKeywordDataApi(message: string) {
  const apiUrl = process.env.REACT_APP_FETCH_KEYWORD_DATA_API!;
  const params = new URLSearchParams();
  const userToken = localStorage.getItem('user_token');
  params.append('free_input_word', message);

  if (userToken) {
    params.append('id', userToken);
  }
  const option = {
    timeout: 6000
  };
  return axios.post(apiUrl, params, option).then(response => response.data);
}

export function* fetchKeywordData(action: IFetchKeywordData) {
  try {
    const keywords = yield call(fetchKeywordDataApi, action.payload.message);
    if (keywords.length > 0 && keywords[0] === 'api_err_01') {
      throw new Error('通信に失敗しました');
    }
    const chatbasedata = action.payload.chatbasedata;
    // const keywords = ["最初の質問24", "web"]
    yield delay(1500);
    yield put({
      type: ChatMessageAction.FETCH_KEYWORD_DATA_SUCCESS,
      payload: {
        keywords,
        chatbasedata
      }
    });
  } catch (e) {
    yield delay(1500);
    yield put({
      type: ChatMessageAction.FETCH_KEYWORD_DATA_FAILURE,
      message: e.message
    });
    yield delay(2000);
    yield put({ type: ChatMessageAction.RETURN_ROOT_MESSAGE });
  }
}

/**
 * logを残すためにpostしている、apiから回答はとっていない
 * postLogと書くとユーザー心理的にあまり気分が良くないかもしれないのでgetAnswerとしている。
 */
function getAnswerApi(elementId: string) {
  const apiUrl = process.env.REACT_APP_INSERT_LOG_API!;
  const params = new URLSearchParams();
  const userToken = localStorage.getItem('user_token');
  params.append('element-id', elementId);
  if (userToken) {
    params.append('id', userToken);
  }
  return axios.post(apiUrl, params).then(response => response.data);
}

export function* getAnswer(action: any) {
  try {
    yield call(getAnswerApi, action.payload.elementId);
    yield put({
      type: ChatMessageAction.GET_ANSWER_SUCCESS
    });
  } catch (e) {
    yield put({
      type: ChatMessageAction.GET_ANSWER_FAILURE,
      message: e.message
    });
  }
}
function insertVisitLogApi() {
  const apiUrl = process.env.REACT_APP_INSERT_START_ACTION_LOG_API!;
  const params = new URLSearchParams();
  const userToken = localStorage.getItem('user_token');
  if (userToken) {
    params.append('id', userToken);
  }
  return axios.post(apiUrl, params).then(response => response.data);
}

export function* insertVisitLog(action: any) {
  try {
    yield call(insertVisitLogApi);
    yield put({ type: ChatMessageAction.INSERT_VISIT_LOG_SUCCESS });
  } catch (e) {
    yield put({
      type: ChatMessageAction.INSERT_VISIT_LOG_FAILURE,
      message: e.message
    });
  }
}

export const chatMessageSaga = [
  takeEvery(ChatMessageAction.INSERT_VISIT_LOG_REQUEST, insertVisitLog),
  takeEvery(ChatMessageAction.FETCH_CHATBOT_DATA_REQUEST, fetchChatData),
  takeEvery(ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST, fetchKeywordData),
  takeEvery(ChatMessageAction.GET_ANSWER_REQUEST, getAnswer)
];
// export function* chatMessageSaga() {
//   yield all([
//     yield takeEvery(ChatMessageAction.INSERT_VISIT_LOG_REQUEST, insertVisitLog),
//     yield takeEvery(
//       ChatMessageAction.FETCH_CHATBOT_DATA_REQUEST,
//       fetchChatData
//     ),
//     yield takeEvery(
//       ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST,
//       fetchKeywordData
//     ),
//     yield takeEvery(ChatMessageAction.GET_ANSWER_REQUEST, getAnswer)
//   ]);
// }
